
import "./date.css";
function Date({ date }) {
  return <div className="date">on {date}</div>;
}

export default Date;
